import CryptoJS from "crypto-js";

export const Encryption = (id) => {
  const secretKey = process.env.REACT_APP_SECRET_KEY; // Replace with your secret key
  const encrypted = CryptoJS.AES.encrypt(id?.toString(), secretKey)?.toString();

  // Convert standard Base64 -> URL-safe Base64. This just re-maps the
  // character set of the SAME OpenSSL-format string (salt stays fully
  // embedded, nothing is discarded) so it can never contain '/' or '+'
  // — the characters that trigger Apache's %2F rejection.
  const urlSafeId = encrypted
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, ""); // strip padding; reconstructed on decode

  return urlSafeId; // already URL-safe — no encodeURIComponent needed
};

export const Decryption = (id) => {
  if (!id) return null;
  const secretKey = process.env.REACT_APP_SECRET_KEY; // Replace with your secret key

  try {
    // decodeURIComponent handles OLD tokens (which were percent-encoded,
    // e.g. %2B/%2F/%3D). It's a harmless no-op for NEW tokens, since -, _
    // are never percent-encoded.
    let standardBase64 = decodeURIComponent(id)
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    // Restore Base64 padding (only new tokens need this; old tokens are
    // already correctly padded, so this loop does nothing for them).
    while (standardBase64.length % 4 !== 0) {
      standardBase64 += "=";
    }

    const decryptedId = CryptoJS.AES.decrypt(
      standardBase64,
      secretKey,
    )?.toString(CryptoJS.enc.Utf8);
    const parsed = parseInt(decryptedId);
    return isNaN(parsed) ? null : parsed;
  } catch (e) {
    console.error("Token decryption failed:", e);
    return null; // let the calling component handle "invalid link" instead of the app crashing
  }
};

// import CryptoJS from "crypto-js";

// export const Encryption = (id) => {
//   const secretKey = process.env.REACT_APP_SECRET_KEY; // Replace with your secret key
//   const encryptedId = CryptoJS.AES.encrypt(id?.toString(), secretKey);
//   const urlSafeId = CryptoJS.enc.Base64url.stringify(encryptedId.ciphertext);
//   return urlSafeId;
// };

// export const Decryption = (id) => {
//   const secretKey = process.env.REACT_APP_SECRET_KEY; // Replace with your secret key
//   const parsedId = CryptoJS.enc.Base64url.parse(id);
//   const decryptedId = CryptoJS.AES.decrypt(
//     { ciphertext: parsedId },
//     secretKey
//   )?.toString(CryptoJS.enc.Utf8);
//   return parseInt(decryptedId);
// };
